var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { mx } from "@springcare/dsm";
export var sizes = __assign(__assign({}, mx.sizes), { max: "max-content", min: "min-content", full: "100%", container: __assign({}, mx.breakpoints) });
